import { Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step, StepStatus, STEP_FORM_GROUP } from '../../dialog/issue-transaction-dialog2/issue-transaction-dialog2-component-classes';

@Component({
  selector: 'app-notification-builder-summary',
  templateUrl: './notification-builder-summary.component.html',
  styleUrls: ['./notification-builder-summary.component.css']
})
export class NotificationBuilderSummaryComponent {

  StepStatus = StepStatus;

  constructor(
    @Inject(STEP_FORM_GROUP) public formGroup: FormGroup,
    @Inject('step') public step: Step
  ) { }

}
